import React from 'react';
import styled from 'styled-components';
import SearchInput from '../../../components/filters/SearchInput';
import FilterSelect from '../../../components/filters/FilterSelect';
import { Option } from 'types/types';

interface Props {
  searchValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchClear: () => void;
  searchPlaceholder?: string;

  statusOptions: Option[];
  selectedStatuses: Option[];
  onStatusChange: (selected: Option[]) => void;

  formatOptions: Option[];
  selectedFormats: Option[];
  onFormatChange: (selected: Option[]) => void;

  // When true, only the search input is shown (used for Copy Groups view).
  showOnlySearchFilter?: boolean;

  // Disables the search input, used when there is nothing to search for.
  searchDisabled?: boolean;
}

const DashboardFilters: React.FC<Props> = ({
  searchValue,
  onSearchChange,
  onSearchClear,
  searchPlaceholder = 'Search EPD',
  statusOptions,
  selectedStatuses,
  onStatusChange,
  formatOptions,
  selectedFormats,
  onFormatChange,
  showOnlySearchFilter = false,
  searchDisabled = false,
}) => (
  <Wrapper $showFilters={!showOnlySearchFilter}>
    <SearchWrapper>
      <SearchInput
        value={searchValue}
        onChange={onSearchChange}
        onClear={onSearchClear}
        placeholder={searchPlaceholder}
        disabled={searchDisabled}
      />
    </SearchWrapper>

    {!showOnlySearchFilter && (
      <>
        <Divider />

        <StatusWrapper>
          <FilterSelect isMulti label="Status" options={statusOptions} value={selectedStatuses} onChange={onStatusChange} />
        </StatusWrapper>

        <Divider />

        <FormatWrapper>
          <FilterSelect isMulti label="Format" options={formatOptions} value={selectedFormats} onChange={onFormatChange} />
        </FormatWrapper>
      </>
    )}
  </Wrapper>
);

const Wrapper = styled.div<{ $showFilters: boolean }>`
  width: ${(props) => (props.$showFilters ? '714px' : '814px')};
  height: 40px;
  display: grid;
  grid-template-columns: ${(props) => (props.$showFilters ? '234px 1px 249px 1px 229px' : '814px')};
  align-items: center;

  background-color: ${(props) => props.theme.colors.elementsDropDown};
  border-radius: 4px;
`;

const SearchWrapper = styled.div`
  min-width: 234px;
`;

const StatusWrapper = styled.div`
  width: 249px;
`;

const FormatWrapper = styled.div`
  width: 229px;
`;

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${(props) => props.theme.colors.secondaryGray};
`;

export default DashboardFilters;
